import { query, where } from "firebase/firestore";
import getAdminsRef from "../admins/getAdminsRef";

const getAssistantsQuery = () => {
  return query(getAdminsRef(), where('role', '==', 'assistant'));
}

export default getAssistantsQuery;